import { SUBURBS, IMAGES } from "../../data/site";

export const Areas = () => (
    <section id="areas" data-testid="areas-section" className="bg-slate-50 border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 md:py-16">
            <div className="grid lg:grid-cols-5 gap-8 items-start">
                <div className="lg:col-span-3">
                    <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0F2E52] mb-3">
                        Areas We Service
                    </h2>
                    <p className="text-base md:text-lg leading-relaxed text-slate-700 mb-4">
                        Based around <span className="font-semibold text-[#0F2E52]">Semaphore SA 5019</span>, we
                        provide onsite computer help throughout Semaphore and Adelaide's western suburbs.
                    </p>
                    <ul className="flex flex-wrap gap-2" data-testid="suburb-list">
                        <li className="bg-[#0F2E52] text-white text-xs font-semibold rounded-full px-3 py-1.5">
                            Semaphore SA 5019
                        </li>
                        {SUBURBS.map((suburb) => (
                            <li
                                key={suburb}
                                data-testid={`suburb-${suburb.toLowerCase().replace(/\s+/g, "-")}`}
                                className="bg-slate-50 border border-slate-200 text-slate-700 text-xs font-medium rounded-full px-3 py-1.5"
                            >
                                {suburb}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="lg:col-span-2">
                    <img
                        src={IMAGES.local}
                        alt="Semaphore foreshore in Adelaide's western suburbs"
                        data-testid="areas-image"
                        className="rounded-2xl w-full object-cover max-h-64 lg:max-h-none lg:aspect-[4/3] shadow-sm border border-slate-100"
                        loading="lazy"
                    />
                    <p className="text-xs text-slate-500 mt-2">Semaphore foreshore — our home turf.</p>
                </div>
            </div>
        </div>
    </section>
);
